import React from "react";
import PropTypes from "prop-types";
import { Search } from "react-feather";
import { Input } from "reactstrap";
import styled from "styled-components";

const Wrapper = styled.div`
  .form-control {
    box-shadow: none;
    background-clip: padding-box;
    display: block;
    width: 100%;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.25;
    padding-left: 2.5rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:focus {
      border-color: ${({ theme }) => theme.colors.systemBlue};
    }
  }
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 0px;
  z-index: 1;
  display: block;
  width: 2.5rem;
  height: 50px;
  line-height: 2.5rem;
  justify-content: center;
  display: flex;
  align-items: center;
`;

const StyledSearchIcon = styled(Search)`
  color: ${({ theme }) => theme.colors.iconBlue};
`;

const SearchBarComponent = ({ onChangeSearch, isDisabled = false, value }) => {
  return (
    <Wrapper>
      <Input
        value={value}
        onChange={onChangeSearch}
        disabled={isDisabled}
        placeholder="Search"
      />
      <IconWrapper>
        <StyledSearchIcon size="20" />
      </IconWrapper>
    </Wrapper>
  );
};

export default SearchBarComponent;

SearchBarComponent.propTypes = {
  onChangeSearch: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};
